/**
 * Opens/closes the collapsed shipping calculator ("Calcular frete e prazo")
 * on the product page. The slide animation itself is pure CSS (grid-rows
 * transition); this only flips the state and keeps it accessible:
 * aria-expanded on the button, and `inert` on the closed panel so its CEP
 * field can't be reached with Tab while hidden.
 */
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.care4-shipping__toggle');
    if (!toggle) return;

    var root = toggle.closest('[data-care4-shipping]');
    var panel = root && root.querySelector('.care4-shipping__panel');
    if (!panel) return;

    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('is-open', open);
    panel.inert = !open;

    if (open) {
      var input = panel.querySelector('input');
      // Wait for the slide-open, then focus the CEP field (without scrolling
      // the page, the panel is already right under the button).
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 250);
    }
  });
})();
